function normalizeReference(reference = {}) {
  const normalized = {};

  if (reference.id !== undefined && reference.id !== null && reference.id !== "") {
    // 页面 ID 已超过 Number.MAX_SAFE_INTEGER，始终按字符串透传和比较。
    normalized.id = String(reference.id);
  }

  const url = String(reference.url || "").trim();
  if (url) {
    normalized.url = url;
  }

  const showType = String(reference.showType || "").trim();
  if (showType) {
    normalized.showType = showType;
  }

  return normalized;
}

function referenceKey(reference = {}) {
  const normalized = normalizeReference(reference);
  return normalized.id
    ? `id:${normalized.id}`
    : `url:${normalized.url || ""}|showType:${normalized.showType || ""}`;
}

export function findActivePageByReference(dataList = [], reference = {}) {
  const normalized = normalizeReference(reference);

  if (normalized.id) {
    return dataList.find((item) => String(item?.id || "") === normalized.id) || null;
  }

  return dataList.find((item) => {
    if (String(item?.url || "").trim() !== normalized.url) {
      return false;
    }
    return !normalized.showType
      || String(item?.showType || "").trim() === normalized.showType;
  }) || null;
}

/**
 * 将同一个事件循环内发起的活动页查询合并成一次批量请求。
 */
export function createActivePageBatchQueue(fetchBatch) {
  let pending = [];
  let flushScheduled = false;

  async function flush() {
    flushScheduled = false;
    const currentPending = pending;
    pending = [];

    const referenceMap = new Map();
    currentPending.forEach(({ reference }) => {
      referenceMap.set(referenceKey(reference), normalizeReference(reference));
    });

    try {
      const response = await fetchBatch([...referenceMap.values()]);
      const dataList = response?.data?.dataList || [];
      currentPending.forEach(({ reference, resolve }) => {
        resolve(findActivePageByReference(dataList, reference));
      });
    } catch (error) {
      currentPending.forEach(({ reject }) => reject(error));
    }
  }

  return {
    load(reference) {
      return new Promise((resolve, reject) => {
        pending.push({
          reference: normalizeReference(reference),
          resolve,
          reject,
        });

        if (!flushScheduled) {
          flushScheduled = true;
          queueMicrotask(flush);
        }
      });
    },
  };
}
